import { render, staticRenderFns } from "./LeagueTable.vue?vue&type=template&id=9e432148"
import script from "./LeagueTable.vue?vue&type=script&lang=js"
export * from "./LeagueTable.vue?vue&type=script&lang=js"
import style0 from "./LeagueTable.vue?vue&type=style&index=0&id=9e432148&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9e432148')) {
      api.createRecord('9e432148', component.options)
    } else {
      api.reload('9e432148', component.options)
    }
    module.hot.accept("./LeagueTable.vue?vue&type=template&id=9e432148", function () {
      api.rerender('9e432148', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Sector/Feed/LeagueTable.vue"
export default component.exports